/**
 * @fileoverview Service para operações com usuário atual.
 *
 * Gerencia dados do usuário logado, incluindo:
 * - Busca de dados do usuário atual (me)
 * - Listagem de usuários (legado)
 * - Atualização de perfil
 *
 * @module services/UserService
 * @see {@link module:typedef~User} para definição de User
 */

import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

/**
 * Service de usuário.
 * @namespace userService
 */
const userService = {
  /**
   * Busca dados completos do usuário logado.
   * Inclui unidades administrativas, permissões e configurações.
   *
   * @returns {Promise<import('axios').AxiosResponse<UserComplete>>}
   */
  getUser() {
    return axios.post('users/me');
  },

  /**
   * Busca lista de todos os usuários.
   *
   * @returns {Promise<import('axios').AxiosResponse<User[]>>}
   * @deprecated Usar endpoint específico de funcionários
   */
  getUsers() {
    // por enquanto, deixa esse método porque ele está sendo utilizado em algum lugar e não temos tempo de refatorar esse endpoint
    return axios.get('users');
  },

  /**
   * Atualiza dados do usuário.
   *
   * @param {Object} params - Parâmetros
   * @param {number} params.id - ID do usuário
   * @param {Object} params.data - Dados a atualizar
   * @param {string} [params.data.name] - Nome
   * @param {string} [params.data.email] - Email
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  updateUser({id, data}) {
    return axios.patch(`users/${ id }`, {user: data});
  },
};

export default userService;



// WEBPACK FOOTER //
// ./src/services/UserService.js